import React, { useState } from 'react';
import { ChatContext } from './ChatContext';
import { Message } from './types';

export const ChatProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [conversationId, setConversationId] = useState<string | undefined>(undefined);
  const [inputValue, setInputValue] = useState<string>('');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isInputFocused, setIsInputFocused] = useState<boolean>(false);
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <ChatContext.Provider
      value={{
        messages,
        setMessages,
        conversationId,
        setConversationId,
        inputValue,
        setInputValue,
        isOpen,
        setIsOpen,
        isLoading,
        setIsLoading,
        isInputFocused,
        setIsInputFocused,
        isExpanded,
        setIsExpanded
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
